import {Parameter, Tsa} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export class PortalTsa extends Tsa implements Parameter {
	public enabled?: boolean;

	constructor(data: any) {
		super(data);

		this.enabled = FunctionHelper.exists(data?.enabled) ? data.enabled : false;
	}

	public static getEnabledDefault(): boolean {
		return false;
	}

	public static fromJson(data: any): PortalTsa {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalTsa(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'enabled': this.enabled,
		};
	}

	public clone(): PortalTsa {
		return PortalTsa.fromJson(this.toJson());
	}
}